import { useTenant } from '#imports'
import { some } from 'lodash-es';

export default defineNuxtRouteMiddleware((to, from) => {
  const {data,status} = useAuth();
  const tenant = useTenant()
  const {public: config} = useRuntimeConfig();
  let currentTenant = tenant || '';
  let canAccessSubdomain = false;

  if(data.value?.user.tenantsData[0].name){
    canAccessSubdomain = some(data.value.user.tenantsData, {name: tenant});
    if(!tenant){
      currentTenant=data.value.user.tenantsData[0].name;
    }
  }
  
  if(tenant && to.name!='login' && status.value == 'unauthenticated'){
    return navigateTo(`${config.baseURL}/login`,{external: true});
  }
  if(to.name=='login' && status.value == 'authenticated'){
    if(data.value.user.tenantsData?.length){
      return navigateTo(`${config.protocol}://${currentTenant}.${config.domain}${config.port?':'+config.port:''}`,{external: true})
    }else{
      return navigateTo(`${config.baseURL}/403`,{external: true});
    }
  }
  if(!!tenant){
    if(!canAccessSubdomain){
      return navigateTo(`${config.baseURL}/503`,{external: true});
    }
    if(tenant=='admin'){
      return navigateTo(`${config.protocol}://${currentTenant}.${config.domain}${config.port?':'+config.port:''}/admin`,{external: true});
    }
  }
});